import { AiModelsAdmin } from "@/features/admin/AiModelsAdmin";
import { useAppShell } from "@/shell/app-shell-context";

export function AiModelsAdminRoute() {
  const { token } = useAppShell();
  return <AiModelsAdmin token={token} />;
}
